






















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
class ResetPasswordPO {
  newPassword: string;
  confirmPassword: string;
  tenantId: number;
  userId: number;
}

@Component
export default class ResetPassword extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 1 }) tenantId: number;
  entity: ResetPasswordPO = new ResetPasswordPO();

  async created() { }

  save() {
    (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (this.entity.newPassword != this.entity.confirmPassword) {
        this.$Modal.info({
          title: this.L("Tips"),
          content: this.L("PasswordNoSame"),
        });
        return;
      }
      if (valid) {
        this.entity.userId = 1;
        await this.$store
          .dispatch({
            type: "user/resetPassword",
            data: this.entity,
          })
          .then((val) => {
            this.$Modal.info({
              title: this.L("Tips"),
              content: val,
            });
          })
          .catch((err) => {
            this.$Modal.error({
              title: this.L("Tips"),
              content: err,
            });
          });
        (this.$refs.roleForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  roleRule = {
    newPassword: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("NewPassword")),
        trigger: "blur",
      },
    ],
    confirmPassword: [
      {
        required: true,
        message: this.L(
          "FieldIsRequired",
          undefined,
          this.L("ConfirmPassword")
        ),
        trigger: "blur",
      },
    ],
  };
  //租户id
  @Watch("tenantId")
  getitemId() {
    this.entity.tenantId = this.tenantId;
  }
}
